import { Box, Typography } from "@mui/material";
import { colors } from "../../../../theme/colors";
import { useBRLmoney } from "../../../../hooks/useBRLmoney";

import { DrawerCheckout } from "../../../../components/AtomicDesign/Molecules";
import { useState } from "react";
import { PaymentModal } from "../../../../components/AtomicDesign/Organisms";
import { useBreakpoints } from "../../../../hooks/useBreakpoins";

interface Props {
  setStep: VoidFunction;
  selectedProducts: CartXProduct[];
  cleanStateCart: VoidFunction;
  step: number;
  selectedAddressID: number;
  setSelectedAddressID: (addressID: number) => void;
  setSelectedFrete: (data: { freteType: string; value: string }) => void;
  selectedFrete: { freteType: string; value: string };
}

export function CheckoutStep({
  setStep,
  selectedProducts,
  cleanStateCart,
  step,
  selectedAddressID,
  setSelectedAddressID,
  setSelectedFrete,
  selectedFrete,
}: Props) {
  const { BRLmoney } = useBRLmoney();
  const { isMobile } = useBreakpoints();
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [payButtonDisabled, setPayButtonDisabled] = useState(false);

  const makeOrder = () => {
    setOpenPaymentModal(true);
  };

  return (
    <Box p={isMobile ? 0 : 5}>
      <Box
        display={"flex"}
        flexWrap={"wrap"}
        justifyContent={isMobile ? "center" : "flex-start"}
        width={isMobile ? "fit-content" : "100%"}
        gap={1}
        mt={2}
        sx={{ background: colors.gray[100], p: 1 }}
      >
        {selectedProducts?.length > 0 ? (
          selectedProducts?.map((item, index) => (
            <Box
              key={index}
              display={"flex"}
              alignItems={"center"}
              flexDirection={"column"}
              width={230}
              sx={{ background: "#FFFFFF", borderRadius: 3 }}
            >
              <Box
                display={"flex"}
                alignItems={"center"}
                flexDirection={"column"}
                justifyContent={"center"}
              >
                <Box width={150} height={150} pl={1}>
                  <img
                    src={item?.product?.productsImages[0]?.code}
                    style={{
                      objectFit: "contain",
                      width: 150,
                      height: 150,
                      borderRadius: 5,
                    }}
                    alt={item?.product?.name}
                  />
                </Box>

                <Typography
                  overflow={"hidden"}
                  ml={1}
                  textOverflow={"ellipsis"}
                  textAlign={"center"}
                  height={48}
                >
                  {item?.product?.name}
                </Typography>

                <Box
                  width={200}
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    minWidth={100}
                    textAlign={"center"}
                    width={"100%"}
                    fontSize={14}
                    color={colors.purple[500]}
                  >
                    Quantidade
                  </Typography>
                  <Typography
                    textAlign={"center"}
                    width={"100%"}
                    fontSize={16}
                    fontWeight={600}
                    color={colors.purple[500]}
                  >
                    {item?.quantity}
                  </Typography>
                </Box>

                <Box
                  width={200}
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    minWidth={100}
                    textAlign={"center"}
                    width={"100%"}
                    fontSize={14}
                    color={colors.purple[500]}
                  >
                    Valor total
                  </Typography>
                  {item?.product?.discountPrice > 0 ? (
                    <Box display={"flex"} flexWrap={"wrap"} gap={1}>
                      <Typography
                        sx={{
                          fontSize: "20px",
                          fontWeight: 700,
                          textAlign: "left",
                          color: colors.green[400],
                        }}
                      >
                        {BRLmoney(
                          item?.product?.discountPrice * item?.quantity
                        )}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "15px",
                          fontWeight: 500,
                          textAlign: "left",
                          color: colors.textGrey[500],
                          textDecoration: "line-through",
                        }}
                      >
                        {BRLmoney(item?.product?.price * item?.quantity)}
                      </Typography>
                    </Box>
                  ) : (
                    <Typography
                      sx={{
                        fontSize: "18px",
                        fontWeight: 500,
                        textAlign: "left",
                        color: colors.textGrey[500],
                      }}
                    >
                      {BRLmoney(item?.product?.price)}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          ))
        ) : (
          <Typography>Seu carrinho está vazio</Typography>
        )}
      </Box>

      <DrawerCheckout
        fullPrice={selectedProducts.reduce((acc, next) => {
          if (next?.product?.discountPrice > 0) {
            return acc + next?.product?.discountPrice * next.quantity;
          }
          return acc + next.product.price * next.quantity;
        }, 0)}
        totalItens={selectedProducts.reduce((acc, next) => {
          return acc + next.quantity;
        }, 0)}
        nextStep={makeOrder}
        backStep={setStep}
        btnText={
          selectedProducts.reduce((acc, next) => {
            return acc + next.product.price * next.quantity;
          }, 0) > 0
            ? "Pagar"
            : "Fazer o pedido"
        }
        selectedProducts={selectedProducts}
        showBackBTN={step === 2}
        addressToOrder={setSelectedAddressID}
        selectedAddressID={selectedAddressID}
        setSelectedFrete={setSelectedFrete}
        selectedFrete={selectedFrete}
        disablePayButton={payButtonDisabled}
      />

      <PaymentModal
        cleanStateCart={cleanStateCart}
        selectedProducts={selectedProducts}
        itensInfo={{
          totalItens: selectedProducts.reduce(
            (acc, next) => acc + next?.quantity,
            0
          ),
          totalValue: selectedProducts.reduce((acc, next) => {
            return acc + next.product.price * next.quantity;
          }, 0),
          addressID: selectedAddressID,
        }}
        open={openPaymentModal}
        setOpen={setOpenPaymentModal}
        selectedFrete={selectedFrete}
        disablePayButton={() => setPayButtonDisabled(true)}
      />
    </Box>
  );
}
